export default class User {
    constructor(username, email, password,name) {
      this.username = username;
      this.email = email;
      this.password = password;
      this.name=name;
    }
  }